if (!customElements.get('rr-free-shipping')) {
  customElements.define('rr-free-shipping', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.announcement-bar-section');
      this.defaultAnnouncement = this.querySelector('[data-rr-default-announcement]');
      this.cartAnnouncement = this.querySelector('[data-rr-cart-announcement]');
      this.remaining = this.querySelector('[data-rr-remaining]');
      this.amount = this.querySelector('[data-rr-shipping-amount]');
      this.unlocked = this.querySelector('[data-rr-unlocked]');
      this.threshold = Number(this.dataset.threshold);
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en-US', {
        style: 'currency', currency: this.dataset.currency || 'USD',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      this.version = 0;
      this.updateHeight = () => {
        const height = this.dataset.hasItems === 'true' ? this.section.offsetHeight : 0;
        document.documentElement.style.setProperty('--rr-announcement-height', `${height}px`);
      };
      this.onCartUpdate = (event) => {
        if (Number.isFinite(event?.cartData?.item_count) && Number.isFinite(event?.cartData?.total_price)) {
          this.version += 1;
          this.render(event.cartData);
        } else {
          this.refresh();
        }
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
      }
      this.onPageShow = () => this.refresh();
      this.onVisibility = () => { if (!document.hidden) this.refresh(); };
      window.addEventListener('pageshow', this.onPageShow);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.resizeObserver = new ResizeObserver(this.updateHeight);
      this.resizeObserver.observe(this.section);
      this.updateHeight();
    }
    disconnectedCallback() {
      this.version += 1;
      this.unsubscribe?.();
      this.resizeObserver?.disconnect();
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.documentElement.style.removeProperty('--rr-announcement-height');
    }
    async refresh() {
      const version = ++this.version;
      try {
        const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (this.isConnected && version === this.version) this.render(cart);
      } catch {}
    }
    render(cart) {
      const hasItems = cart.item_count > 0;
      const remaining = Math.max(0, this.threshold - cart.total_price);
      this.dataset.hasItems = String(hasItems);
      this.defaultAnnouncement.hidden = hasItems;
      this.cartAnnouncement.hidden = !hasItems;
      this.remaining.hidden = remaining === 0;
      this.unlocked.hidden = remaining > 0;
      this.amount.textContent = this.formatter.format(remaining / 100);
      this.updateHeight();
    }
  });
}
